//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	// import dTProgress from '@/crowd_fund/Progress'
	import dTProgress from '@/components/prog/Progresshelp'
	// import open from '@/assets/js/openWin'
	export default {
		components: {
			dTProgress
		},
		props: ['dTDetail','type'],
		data() {
			return {
				acr001: this.$route.params.acr001,
				itemTitle: this.G("itemTitle"),
				itemDescription: this.G("itemDescription"),
				companyLogo: this.G("companyLogo"),
				companyName: this.G("companyName"),
				details: '',
				restday:''
			}
		},
		computed:{
			alreadyMoney() {
				if(this.details.alreadyMoney>=1000000){
					let divide = this.details.alreadyMoney/10000
					return divide.toFixed(3).slice(0,-1)
				}else{
					return this.details.alreadyMoney
				}
			},
			planMoney() {
				if(this.details.planMoney>=1000000){
					let divide = this.details.planMoney/10000
					return divide.toFixed(3).slice(0,-1)
				}else{
					return this.details.planMoney
				}
			},
		},
		watch: {
			details(){
				this.restday = this.datedifferent()
			}
		},
		methods: {
			datedifferent() {
				let iDays
				if(this.details.aar021){
					let deadline = this.details.aar021.replace(/[.]/g,'-')
					let currentdata = new Date().toLocaleDateString().replace(/[/]/g,'-')
					let dateSpan
					let tempDate
	        currentdata = Date.parse(currentdata);
	        deadline = Date.parse(deadline);
	        dateSpan = deadline - currentdata;
	        dateSpan = Math.abs(dateSpan);
	        iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
				}
        return iDays
			},
			zcDetailLink() {
				if(this.isWeixinCient()) {

				}else {

				}
			},
			getDetail () {
	   		let data={
	        acr001: this.acr001
	      }
        this.$https.post(this.BASE_URL+"cfs/zc/project/getLoadxmxx",
          data
        )
        .then(res => {
          this.details = res.data.data;
         	this.$emit("dTDetailChild",this.details)
          console.log(res.data.data);
        })
        .catch(function(err) {
        	console.log(err);
        })
	   	}
		},
		mounted() {
			this.getDetail()
			this.restday = this.datedifferent()
		}

	}



// WEBPACK FOOTER //
// ./src/components/donateTogether/publishTop.vue